import React from 'react';
import {
  Additional_configuration_API,
  Additional_configuration_API_list, addPathToList,
  Authentication_str,
  Available_authentication_methods,
  Available_authentication_methods_list,
  Configure_customers_transactions,
  Enable_authentication_launch,
  Enable_authentication_transactions,
  Single_authentication_recommended,
} from '../utils/DictionaryManagementUtils';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import NoteMessage from '../components/PanelsComponents/Text/NoteMessage';
import ExpandedList from '../components/PanelsComponents/General/ExpandedList';
import CheckBoxMenu from '../components/PanelsComponents/General/CheckBoxMenu';

//= ========================================================================
const Panel_T02_launch_auth = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'face_id_to_approve',
    'touch_id_to_approve',
    'enter_your_pin_code',
    'enter_the_code_you_just_received',
    'enter_credentials',
    'username',
    'password',
    'approve',
    'change_id',
  ];
  const apiTextList = [
    'auth_password_error',
    'auth_pin_code_error',
    'auth_wrong_code_error',
  ];
  const { auth } = globJSON.configurations.launch;
  const tapping_the_bank_icon = auth.auth_upon_tapping_the_bank_icon;
  const transactions = auth.auth_upon_transactions;
  const onValueChanged = (key, value) => {
    auth[key] = value;
    if (key === 'auth_upon_transactions') {
      globJSON.configurations.services.screens_ordering.filter((serviceKey) => globJSON.configurations.services[serviceKey].selected)
        .forEach((serviceKey) => {
          globJSON.configurations.services[serviceKey].auth_within = value;
        });
    }
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Authentication_str}
      editTextList={addPathToList(editTextList, 'configurations/launch/auth/')}
      apiTextList={apiTextList}
      tooltipsTitles={globJSON.configurations.launch.screens_ordering}
      paragraph={Configure_customers_transactions}
      isHollow
      language={language}
      paddingVertical={25}
    >
      <SwitcherPanel
        text={Enable_authentication_launch}
        value={tapping_the_bank_icon}
        onValueChanged={(value) => {
          onValueChanged('auth_upon_tapping_the_bank_icon', value);
        }}
      />
      <SwitcherPanel
        text={Enable_authentication_transactions}
        value={transactions}
        onValueChanged={(value) => {
          onValueChanged('auth_upon_transactions', value);
        }}
        marginTop={8}
      >
        <CheckBoxMenu
          globJSON={globJSON}
          onConfigChanged={onConfigChanged}
          transactions={transactions}
        />
      </SwitcherPanel>

      {tapping_the_bank_icon && transactions
      && <NoteMessage language={language}>{Single_authentication_recommended}</NoteMessage>}
      <BreakLine marginTop={14} />
      <ExpandedList headline={Additional_configuration_API} textList={Additional_configuration_API_list} />
      <ExpandedList headline={Available_authentication_methods} textList={Available_authentication_methods_list} />
    </FullPagePanel>
  );
};

export default Panel_T02_launch_auth;
